import { Component, Input, OnInit } from '@angular/core';
import { ISubsetsFilter } from '../ifilter';

@Component({
    selector: '[app-subset-filter]',
    templateUrl: './subset-filter.component.html',
    styleUrls: ['./subset-filter.component.scss'],
    host: { 'class': 'control' },
    standalone: false
})
export class SubsetFilterComponent implements ISubsetsFilter {

  @Input()
  public Subsets: Array<string> = [];

  @Input()
  public Subset: string = '';

  QueryParamPrefix: string= '';

  constructor() { }

  public formatSubset(value: string): string {
    if (!value) {
      return '';
    }
    return value
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/^./, (letter) => letter.toUpperCase());
  }
}
